"use client";

import Button from "@/components/atoms/Button";
import Icon from "@/components/atoms/Icon";
import Sprite from "@/components/atoms/Sprite";
import { useTranslation } from "@/i18n/client";
import type { AllowedLanguages } from "@/types/generic";

interface LoginSectionProps {
  locale: AllowedLanguages;
}

export const LoginSection = ({ locale }: LoginSectionProps) => {
  const { t } = useTranslation(locale);

  return (
    <div className="relative overflow-hidden bg-yellow-600 p-6 lg:p-10">
      <div className="relative z-1 grid grid-cols-1 text-center">
        <div>
          <div className="mb-6 inline-flex aspect-square w-16 items-center justify-center rounded-full bg-white">
            <Icon name="profile" className="h-12 w-12 text-black-400" />
          </div>
          <h5 className="!mb-1">
            {t("pages.myvivaldis_register.login_section.title")}
          </h5>
          <div className="text-sm text-black-400">
            {t("pages.myvivaldis_register.login_section.description")}
          </div>
          <Button
            as="link"
            href={`/${locale}/myvivaldis`}
            className="mt-8 min-w-[180px]"
            arrow={false}
          >
            {t("pages.myvivaldis_register.login_section.login_link")}
          </Button>
        </div>
      </div>

      <Sprite className="right-0 top-[-40px] w-[400px] translate-x-[40px]" />
    </div>
  );
};
